import { createContext } from 'react';

/**
 * Переопределяет идентификатор контейнера куда будет отображаться содержимое всех компонентов созданных через createPortal
 */
var defaultContextValue = {
    applicationElementID: 'root',
    rootElement: undefined
};
var PopupsContext = createContext(defaultContextValue);

export { PopupsContext };
